/**
 * Interface popisujici strukturu atributu
 */
export interface IAttributeDescription {
    AttributeName: string;
    CacheType?: string;
    ClassName?: string;
    SupportsEncValue?: boolean;
    Type: string;
    Size?: number;
    Required?: boolean;
    DisplayFormat?: boolean;
    MaxAttributeValue?: number;
    DisplayAttributeType?: string;
    DisplayAttributeName?: string;
}

/**
 * Popis rozhrani atributu pro ulozeni do indexedDb
 */
export interface IAttributeDescriptionDbCache {
    attributeName: string;
    className: string;
    cacheType: string;
    serializedObject: string;
}
